module.exports = __webpack_public_path__ + "static/media/dark.f8a6fe21.jpeg";